import React from 'react'
import styles from './header_.module.css'
import strings from '../../../src/strings/strings.json'
export default function BtnLogin(props) {

    return (
        <button className={styles.btn} onClick={props.onClickHandler}>{strings.general_logInToAccount}</button>
    )
}